var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinesOrStripes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 16,
    viewBox: "0 0 230 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1610_19939)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 230,
    height: 15,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 60.5,
    x2: 2,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.75,
    y1: 60.5,
    x2: 29.75,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.5,
    y1: 60.5,
    x2: 57.5,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.25,
    y1: 60.5,
    x2: 85.25,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 60.5,
    x2: 113,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.75,
    y1: 60.5,
    x2: 140.75,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.5,
    y1: 60.5,
    x2: 168.5,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.25,
    y1: 60.5,
    x2: 196.25,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224,
    y1: 60.5,
    x2: 224,
    y2: 0.5,
    stroke: "black",
    strokeWidth: 12
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 229.5,
    height: 14.5,
    rx: 7.25,
    stroke: "#333333",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1610_19939"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 230,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesOrStripes);
export default __webpack_public_path__ + "static/media/linesOrStripes.1154a2810728adf4f3b160c950caf2a6.svg";
export { ForwardRef as ReactComponent };